<div class="rating-div">
   <!-- <sh-grid> -->
   <div class="star-rating-grid" columns="5" *ngIf="ans" >
      <sh-icon slot="functions" button icon="favorite" class="rating-icon"  
         (mouseenter)="rating=1" (click)="setRating(rating=1)" [disabled]="enable == 0" [active]="enable === 1"
         [ngClass]="{'rating-color': rating >= 1 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" class="rating-icon"  
         (mouseenter)="rating=2" (click)="setRating(rating=2)" [disabled]="enable == 0" [active]="enable === 1"
         [ngClass]="{'rating-color': rating >= 2 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" class="rating-icon" 
         (mouseenter)="rating=3" (click)="setRating(rating=3)" [disabled]="enable == 0" [active]="enable === 1"
         [ngClass]="{'rating-color': rating >= 3 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" class="rating-icon"  
         (mouseenter)="rating=4" (click)="setRating(rating=4)" [disabled]="enable == 0" [active]="enable === 1"
         [ngClass]="{'rating-color': rating >= 4 }"></sh-icon>
      <sh-icon slot="functions" button icon="favorite" class="rating-icon"  
         (mouseenter)="rating=5" (click)="setRating(rating=5)" [disabled]="enable == 0" [active]="enable === 1"
         [ngClass]="{'rating-color': rating >= 5 }"></sh-icon>
   </div>
   <sh-icon class="cancel-icon" slot="functions" button icon="cancel" *ngIf="un==0" (click)="disableRating()">
   </sh-icon>

   <sh-notification class="rating-notify">
      <sh-notification-item id="rating-confirmation" duration='short' [visible]="isShowNotificationSuccess" 
      type="confirmation"
      label="Success">
      {{showSuccessMessage}}
  </sh-notification-item>
   </sh-notification>
   <div columns="1" *ngIf="!ans">
      <span class="stars" id="assetRating">
         <span [ngStyle]="{ 'width': getStars(rating) }"></span>
      </span>
      <sh-button *ngIf="allowToRate()" shape="pill-m" label='Rate this version' class="rating-div" color="secondary"
         (click)="enableRating()" id="rateVersion"></sh-button>
   </div>
   <!-- </sh-grid> -->
</div>